import React from "react";
import { ReactComponent as ExcelIcon } from "../../assets/images/document/Excel.svg";
import { ReactComponent as PdfIcon } from "../../assets/images/document/Pdf.svg";
import { ReactComponent as PowerIcon } from "../../assets/images/document/Power.svg";
import { ReactComponent as WordIcon } from "../../assets/images/document/Word.svg";
import { ReactComponent as ZipIcon } from "../../assets/images/document/Zip.svg";
import { ReactComponent as ZipIconXL } from "../../assets/images/document/Zip_xl.svg";
import { getApiUrl } from "../../utils/apiUrls";
import { openSnackBar } from "../../redux/actions/snackbar.actions";
import instance from "../../utils/axios";
import { saveAs } from "file-saver";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { useParams } from "react-router-dom";
import { apiErrorHandler } from "../../utils/errorHandler";
import CustomButtonLoader from "../../components/global/CustomButtonLoader.component";
import ProgressBar from "../../components/progress-bar/ProgressBar.component";
import { ReactComponent as EmptyIcon } from "../../assets/images/empty/pictorial_icons_set.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular, solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import moment from "moment/moment";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "./DocumentPreviewCotent.styles.css"
import CustomToolTip from "../../components/custom-tooltip/CustomTooltip.component";
import DownloadButton from "./DownloadButton.component";

const keySetter = {
  I: "INTERVIEW",
  G: "GROUP_DISCUSSION",
  T: "ASSESSMENT",
  e: "EVENT",
  S: "FEEDBACK_SURVEY",
  HA: "HOGAN_ASSESSMENTS",
  TA: "TTE_ASSESSMENTS"
};
const extensionKey = {
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ppt: "application/vnd.ms-powerpoint",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  pdf: "application/pdf",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  zip: "application/zip"
}
const DocumentPreviewContent = ({ t }) => {
  const params = useParams();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const envState = useSelector((state) => state.env);

  const [loader, setLoader] = React.useState({
    view: false,
    firstTimeRender: false,
    // download: false,
    // downloadFromHeader: false,
  });
  const [fileResponse, setFileresponse] = React.useState(null);
  const [data, setData] = React.useState({});
  const flag = React.useRef(true);
  const [enlarge, setEnlarge] = React.useState({
    status: false,
    isLoading: false
  });

  const populateIcon = () => {
    switch (data?.documentName?.split(".").pop()) {
      case "doc":
      case "docx":
        return <WordIcon />;
      case "pdf":
        return <PdfIcon />;
      case "xlsx":
      case "xls":
        return <ExcelIcon />;
      case "pptx":
      case "ppt":
        return <PowerIcon />;
      default:
        return <ZipIcon />;
    }
  };
  const [fileExtention, setFileExtention] = React.useState(null);
  React.useEffect(() => {
    document.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
  }, [])
  React.useEffect(() => {
    if (
      !!params?.documentId &&
      !!params?.eventSlug &&
      !!params?.documentString
    ) {
      if (!envState.PRODUCTION && flag.current) {
        // remove the effect of React.StrictMode in local
        flag.current = false;
        return;
      }
      previewFileFetchData();
    }
  }, [params]);
  const previewFileFetchData = async () => {
    try {
      setLoader({ ...loader, view: true, firstTimeRender: true });
      const tokenData = await instance.get(
        `${getApiUrl("getDocumentDetails")}/${params?.eventSlug}/${params.documentId
        }/${!!params.documentString
          ? keySetter[params.documentString]
          : ""}`
      );
      setFileExtention(tokenData.data.documentName.split(".").pop());
      setData({
        documentName: tokenData.data.documentName,
        documentTitle: tokenData.data.documentTitle,
        enableDownloadButton: tokenData.data.enableDownloadButton,
        accessControl: tokenData.data.accessControl
      });

      if (tokenData.data.documentName.split(".").pop() === "zip" || tokenData?.data?.accessControl === "BLOCK_ACCESS") {
        setLoader({ ...loader, view: false, firstTimeRender: true });
        return;
      }

      // Encrypt
      const uniqueCode = user?.userId;
      const JSEncrypt = window.JSEncrypt;

      const getKey = await axios.get(getApiUrl("getSk"));

      const skid = getKey.data.id;
      const rsaKey = getKey.data.key;

      var rsaEncrypt = new JSEncrypt({ default_key_size: 2048 });
      rsaEncrypt.setPublicKey(rsaKey);
      var rsaEncryptedAesKey = rsaEncrypt.encrypt(uniqueCode.toString());
      // Encrypt End
      // Expiration time check
      if (!moment(tokenData.data.expirationTime).isAfter(moment())) {
        setLoader({ ...loader, view: false });
        return;
      }
      const temp = setInterval(() => {
        // console.log("in", moment(tokenData.data.expirationTime).format("MMM DD YYYY hh:mm A"))
        if (!moment(tokenData.data.expirationTime).isAfter(moment())) {
          // if (!moment(1721124538000).isAfter(moment())) {
          setFileresponse(null);
          setLoader({ ...loader, view: false, firstTimeRender: true });
          clearInterval(temp);
        }
      }, [10000]);
      let res;
      const urlString = `${getApiUrl(
        envState.PRODUCTION
          ? "viewDocumentFile"
          : "viewDownloadDocumentFileLocal"
      )}/${params?.eventSlug}/${params.documentId}/${!!params.documentString
        ? keySetter[params.documentString]
        : ""
        }/VIEW?skId=${skid}&key=${encodeURIComponent(rsaEncryptedAesKey.toString())}&documentViewToken=${tokenData.data.documentViewToken
        }`;

      if (!envState.PRODUCTION) {
        res = await instance.get(urlString);
      }

      setFileresponse([
        {
          uri: envState.PRODUCTION
            ? urlString
            : res.data,
          fileType: tokenData.data.documentName.split(".").pop(),
          fileName: tokenData.data.documentName,
        },
      ]);
      setLoader({ ...loader, view: false, firstTimeRender: true });
    } catch (error) {
      setLoader({ ...loader, view: false, firstTimeRender: true });
      if (error.response.data.message === "invalid_access_time") {
        setFileresponse(null);
        return;
      }
      const msgObj = apiErrorHandler(error);
      dispatch(
        openSnackBar({
          msg: t(msgObj.statusText),
          type: "error",
        })
      );
    }
  };

  const emptyPage = () => {
    if (!!fileExtention && ["zip"].includes(fileExtention) && data?.accessControl !== "BLOCK_ACCESS") {
      return (
        <div className="d-flex justify-content-center align-items-center flex-column cm-doc-centre-screen">
          <ZipIconXL />
          <p className="mb-2 mt-3 text-blue-700 fw-semibold">
            {t("preview_not_available")}
          </p>
          <p className="cm-sm-txt mb-3 text-blue-gray-500 fw-medium">
            {t("please_download_this_file_to_view_content_not_available")}
          </p>
          {downloadButton("body")}
        </div>
      );
    }
    return (
      <div className="d-flex justify-content-center align-items-center flex-column cm-doc-centre-screen">
        <EmptyIcon />
        <p className="mb-2 mt-3 text-blue-700 fw-semibold">
          {t("file_is_ not_available")}
        </p>
        <p className="cm-sm-txt mb-0 text-blue-gray-500 fw-medium">
          {t("file_that_you_are_looking_for_not_available")}
        </p>
      </div>
    );
  };
  const downloadButton = (type) => {
    return data.enableDownloadButton ? (
      <DownloadButton
        t={t}
        type={type}
        fileExtention={fileExtention}
        eventId={params.eventSlug}
        documentId={params.documentId}
        documentName={data.documentName}
        extensionKey={extensionKey}
        envState={envState}
        isOtherLoading={false}
        documentString={!!params.documentString
          ? keySetter[params.documentString]
          : ""
        }
      />
    ) : null;
  };

  const handleEnlargeToggle = () => {
    setEnlarge({
      ...enlarge,
      isLoading: true,
    });

    previewFileFetchData();

    setTimeout(() => {
      setEnlarge(prevState => ({
        ...prevState,
        isLoading: false,
        status: !prevState.status,
      }));
    }, 100)

  };

  return (
    <div className="cm-doc-viewer">
      {!loader.view && loader.firstTimeRender ? (
        <>
          {!!data?.documentTitle ? (
            <div
              className="d-flex py-12 px-40 my-auto border-bottom"
              style={{ minHeight: "63px" }}
            >
              <div className="my-auto">{populateIcon()}</div>
              <p className="my-auto ps-2 pt-1 cm-sm-txt flex-grow-1 fw-medium">
                {data?.documentTitle}
              </p>
              {
                ["pdf"].includes(fileExtention) && <CustomToolTip title={enlarge.status ? t("compress") : t("enlarge")}>
                  <span
                    onClick={!enlarge.isLoading && handleEnlargeToggle}
                    className={`border border-action-blue rounded py-2 px-3 cm-pointer text-action-blue ${data.enableDownloadButton ? "me-3" : ""}`}
                  >
                    <FontAwesomeIcon icon={enlarge.status ? solid("down-left-and-up-right-to-center") : solid("up-right-and-down-left-from-center")} />
                  </span>
                </CustomToolTip>
              }
              {["ppt", "pptx"].includes(fileExtention) && data?.accessControl !== "BLOCK_ACCESS" ? <div className={`my-auto d-flex bg-blue-gray-100 navigate-box cm-btn-radius ${data.enableDownloadButton ? "me-2" : ""}`}>
                <FontAwesomeIcon
                  icon={regular("Exclamation-circle")}
                  className="my-auto"
                />
                <p className="my-auto ps-2 cm-sm-txt fw-medium">
                  {t("you_can_use")}
                </p>
                <FontAwesomeIcon
                  icon={solid("left")}
                  className="my-auto ms-1"
                  style={{ padding: "2px" }}
                />
                <FontAwesomeIcon
                  icon={solid("right")}
                  className="my-auto mx-1"
                  style={{ padding: "2px" }}
                />
                <p className="my-auto ps-1 cm-sm-txt fw-medium">
                  {t("on_keyboard_to_navigate_through_slides")}
                </p>
              </div> : null}
              {downloadButton("head")}
            </div>
          ) : null}
          {fileResponse?.length > 0 &&
            !!fileExtention &&
            !["zip"].includes(fileExtention) ? (
            <div
              className={`position-relative cm-doc-width ${["pdf", "zip"].includes(fileExtention)
                ? `${"pdf" === fileExtention ? `${enlarge.status ? "cm-doc-view-pdf-full" : "cm-doc-view-pdf-sm cm-doc-view-pdf"}` : "cm-doc-view mx-1"}`
                : "cm-doc-view-fs"
                }`}
            >
              {
              ["pdf"].includes(fileExtention) ? 
                    !enlarge?.isLoading ? <DocViewer
                      pluginRenderers={DocViewerRenderers}
                      documents={fileResponse}
                      config={{
                        loadingRenderer: {
                          overrideComponent: ProgressBar,
                        },
                        pdfZoom: {
                          defaultZoom: 1,
                          zoomJump: 0.2,
                        },
                        pdfVerticalScrollByDefault: true, // false as default
                      }}
                    /> : null
                  :
                <DocViewer
                  pluginRenderers={DocViewerRenderers}
                  documents={fileResponse}
                  config={{
                    pdfVerticalScrollByDefault: true, // false as default
                    header: {
                      loadingRenderer: {
                        overrideComponent: ProgressBar,
                      },
                    },
                  }}
                />
              }
              {["docx", "xlsx", "doc", "xls", "ppt", "pptx"].includes(fileExtention) ? <div className={"cm-mask-toolBar"} /> : null}
            </div>
          ) : (
            // zip and empty page
            emptyPage()
          )}
        </>
      ) : (
        <div className="py-4 d-flex align-items-center justify-content-center cm-preview-document">
          <ProgressBar />
        </div>
      )}
    </div>
  );
};

export default DocumentPreviewContent;
